export function px(value: any) {
  return isNaN(value) ? value : `${value}px`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/css.ts